<template>
  <div>
    <v-row class="ml-1">
      <strong class="mt-2 mr-2">単語名</strong>
      <v-text-field
        v-model="keyword"
        hide-details
        dense
        @keyup.enter="search"
        class="text-field-search mr-10"
        outlined
      />
      <v-btn color="primary" class="font-weight-black" @click="search">{{
        $t("SEARCH")
      }}</v-btn>

      <v-spacer />
      <v-select
        class="select-record"
        hide-details
        :items="recordsPage"
        v-model="pagination.maxResultCount"
        dense
        outlined
      />
      <v-btn
        color="primary"
        class="ml-2"
        @click="
          $router.push({
            name: 'Create Vocabulary In Detail Category',
            params: $route.params,
          })
        "
        >新規登録</v-btn
      >
    </v-row>
    <v-row class="ml-1">
      <v-layout child-flex>
        <v-data-table
          :headers="headers"
          :items="listVocabulary"
          class="elevation-1 mt-2"
          :loading="loading"
          loading-text="読み込み中。。。待ってください。"
          :items-per-page.sync="pagination.maxResultCount"
          :page="pagination.page"
          hide-default-footer
        >
          <template v-if="listVocabulary.length > 0" v-slot:body="{ items }">
            <tbody>
              <tr v-for="(item, index) in items" :key="index">
                <td>{{ item.name.ja }}</td>
                <td>{{ item.furigana }}</td>
                <td>
                  <span>{{
                    listWordbookBadge.find((e) => e.Id == item.badge) &&
                    item.badgeChecked
                      ? listWordbookBadge.find((e) => e.Id == item.badge).name
                      : ""
                  }}</span>
                </td>
                <td class="text-center">
                  <audio :ref="`audio-${index}`">
                    <source :src="item.audio_url" type="audio/mp3" />
                    Your browser does not support the audio element.
                  </audio>
                  <v-btn
                    color="warning"
                    width="30"
                    height="30"
                    fab
                    small
                    v-if="item.audio_url"
                    dark
                    @click="play(`audio-${index}`)"
                  >
                    <v-icon size="15">fas fa-volume-up</v-icon>
                  </v-btn>
                </td>

                <td class="text-center">
                  <!-- Update vocabulary -->
                  <v-icon
                    size="medium"
                    v-text="`fas fa-pencil-alt`"
                    class="mr-3"
                    @click="
                      $router.push({
                        name: 'Update Vocabulary In Detail Category',
                        params: { ...$route.params, vocabularyId: item.Id },
                      })
                    "
                  />

                  <!-- Delete vocabulary -->
                  <VocabularyDelete
                    :item="item"
                    @resetList="handleGetListVocabulary"
                  />
                </td>
              </tr>
            </tbody>
          </template>

          <template v-slot:no-data>データがありません。</template>
        </v-data-table>
      </v-layout>
    </v-row>
    <BasePagination
      class="mt-2"
      v-if="listVocabulary.length > 0"
      :pageCount="listVocabulary.length"
      :pageSize="pagination.maxResultCount"
      @changePage="changePage"
    />
  </div>
</template>
<script>
import mixin from "@/mixin";
import BasePagination from "@/components/Pagination/BasePagination";
import { getListVocabulary } from "@/api/Vocabulary.api";
import VocabularyDelete from "@/views/vocabularyBook/tab/category/vocabulary/VocabularyDelete.vue";
import { getListBadge } from "@/api/Badge.api";
export default {
  mixins: [mixin.App],
  components: {
    BasePagination,
    VocabularyDelete,
  },
  data() {
    return {
      keyword: "",
      dialog: false,
      loading: false,
      index: 0,
      defaultListVocabulary: [],
      listVocabulary: [],
      listWordbookBadge: [],
      audioPlay: "",
      headers: [
        {
          text: "単語名",
          value: "name.ja",
          width: "30%",
        },
        { text: "ふりがな", value: "furigana", width: "20%" },
        { text: "バッヂ", value: "badge", width: "30%" },
        { text: "音声データ", value: "audio_url", width: "108px" },
        {
          text: "操作",
          align: "center",
          value: "actions",
          sortable: false,
          width: "108px",
        },
      ],
    };
  },
  async created() {
    await this.handleGetListVocabulary();
    await this.getBagdeList();
  },
  methods: {
    changePage(value) {
      this.pagination.page = value;
    },
    async getBagdeList() {
      await getListBadge()
        .then(({ result }) => {
          this.listWordbookBadge = result;
        })
        .catch((error) => {
          this.$toast.error(error);
        });
    },
    async handleGetListVocabulary() {
      this.loading = true;
      console.log(this.$route.query);
      let params = {
        keyword: "",
        category: this.$route.params.categoryId,
        tab: this.$route.params.tabId,
        grammar: "",
        conversation: "",
      };
      this.loadingListVocabulary = true;
      await getListVocabulary(params)
        .then((data) => {
          this.defaultListVocabulary = data.result;
          this.listVocabulary = data.result;
          this.pagination.pageCount = data.totalCount;
          this.loading = false;
        })
        .catch((error) => {
          this.$toast.error(error);
          this.loading = false;
        });
    },
    async search() {
      await this.handleGetListVocabulary();
      const { keyword } = this;
      let keywordSearch = keyword.toLowerCase();
      this.listVocabulary = this.defaultListVocabulary.filter(
        (item) => item.name.ja.toLowerCase().search(keywordSearch) > -1
      );
      this.pagination.pageCount = this.listVocabulary.length;
    },
    play(ref) {
      const { _ } = this;
      if (!this.audioPlay || this.audioPlay == ref) {
        if (this.$refs[ref][0].paused) {
          this.$refs[ref][0].play();
        } else {
          this.$refs[ref][0].pause();
        }
        this.audioPlay = ref;
      } else if (this.audioPlay && this.audioPlay != ref) {
        if (this.$refs[ref][0].paused) {
          _.forEach(this.$refs, (e) => {
            e[0].pause();
          });
          this.$refs[ref][0].play();
        }
        this.audioPlay = ref;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.icon-trash {
  position: absolute;
  right: 5%;
  top: 30%;
  font-size: 16px;
}
</style>